module.exports = __webpack_public_path__ + "img/louvre.33ff79ad.jpg";